import tools from 'utils/tools';

const ProtectedRoute = tools.lazyWithRetry(() =>
  import('layouts/RouteAccessModifiers'),
);
const DashboardLayout = tools.lazyWithRetry(() =>
  import('layouts/DashboardLayout'),
);
const VehicleIndex = tools.lazyWithRetry(() =>
  import('components/pages/Vehicle/VehicleIndex'),
);
const VehicleGet = tools.lazyWithRetry(() =>
  import('components/pages/Vehicle/VehicleGet'),
);
const VehicleForm = tools.lazyWithRetry(() =>
  import('components/pages/Vehicle/VehicleForm'),
);
const OrganizationForm = tools.lazyWithRetry(() =>
  import('components/pages/Vehicle/OrganizationForm'),
);

const vehicleRoutes = [
  {
    path: '/vehicle',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: '', element: <VehicleIndex /> },
      { path: ':id', element: <VehicleGet /> },
      { path: 'add', element: <VehicleForm /> },
      { path: 'edit/:id', element: <VehicleForm /> },
      { path: 'organization/:id', element: <OrganizationForm /> },
    ],
  },
];

export default vehicleRoutes;
